import React from "react";
import { ClipboardCheck } from "lucide-react";

/** Eladói követelmények — admin által szerkeszthető, pipálható checklist. */
export function ListingRequirements({
  requirements = [],
  accepted = {},
  onToggle,
  readOnly = false,
}) {
  if (!requirements.length) return null;

  return (
    <div
      data-testid="listing-requirements"
      className="rounded-2xl border border-white/10 bg-white/[0.02] p-5"
    >
      <div className="flex items-center gap-2 mb-3">
        <ClipboardCheck className="w-4 h-4 text-electric" strokeWidth={1.75} />
        <h3 className="font-heading text-base font-medium">Feltöltési követelmények</h3>
      </div>
      <p className="text-xs text-slate-500 mb-4">
        A hirdetés feladása előtt erősítsd meg az alábbiakat.
        {readOnly ? "" : " A kötelező pontokat ki kell pipálni."}
      </p>
      <ul className="space-y-3">
        {requirements.map((req) => {
          const checked = !!accepted[req.id];
          const optional = !req.required;
          return (
            <li key={req.id}>
              {readOnly ? (
                <div className="flex items-start gap-3 text-sm text-slate-300">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-electric shrink-0" />
                  <span>{req.text}</span>
                  {optional && (
                    <span className="text-[10px] uppercase tracking-wide text-slate-500 shrink-0">opcionális</span>
                  )}
                </div>
              ) : (
                <label
                  data-testid={`listing-req-${req.id}`}
                  className={`flex items-start gap-3 cursor-pointer rounded-xl p-3 border transition-colors ${
                    checked ? "border-electric/40 bg-electric/5" : "border-white/10 hover:border-white/20"
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onToggle?.(req.id)}
                    className="mt-0.5 accent-[#2563EB]"
                  />
                  <span className="text-sm text-slate-200 leading-relaxed">
                    {req.text}
                    {optional && (
                      <span className="block text-[10px] uppercase tracking-wide text-slate-500 mt-1">Opcionális</span>
                    )}
                    {req.required && (
                      <span className="block text-[10px] uppercase tracking-wide text-amber-400/90 mt-1">Kötelező</span>
                    )}
                  </span>
                </label>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export function allRequiredAccepted(requirements, accepted) {
  return (requirements || [])
    .filter((r) => r.required)
    .every((r) => accepted[r.id]);
}
